import * as MetaSiteSearchService from '@wix/ambassador-metasite-search-v2-search-entry/http';
import * as FeaturesManagerService from '@wix/ambassador-premium-features-manager-v1-feature/http';
import * as PremiumCurrencyService from '@wix/ambassador-premium-store-v1-currency/http';
import * as MailboxManagementService from '@wix/ambassador-premium-mailbox-v1-mailbox-management/http';
import { bindDomain, bindMultipleDomains, getSite, listAssignedDomains, listSites, listUnassignedDomains, unbindDomain } from '@wix/ambassador-domains-mydomains-v1-domain/http';
import * as PremiumUserDomain from '@wix/ambassador-domains-userdomain-v1-user-domain/http';
import * as SitesService from '@wix/ambassador-site-list-v2-site/http';
import { PremiumDomainRegistrar } from '@wix/ambassador-premium-domain-registrar/http';
import { WixMetaSiteManagerWebapp } from '@wix/ambassador-wix-meta-site-manager-webapp/http';
import { PremiumStore } from '@wix/ambassador-premium-store/http';
import { PremiumResellerMgmt } from '@wix/ambassador-premium-reseller-mgmt/http';
import { createMetroApiConfig, createProtoV1ApiConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
global.self = global.window || {};
export const MetaSiteSearchApiConfig = createMetroApiConfig(MetaSiteSearchService);
export const SitesListApiConfig = createMetroApiConfig(SitesService);
export const MailboxManagementApiConfig = createMetroApiConfig(MailboxManagementService);
export const PremiumFeaturesManagerApiConfig = createMetroApiConfig(FeaturesManagerService, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  }
});
export const PremiumResellerMgmtApiConfig = createProtoV1ApiConfig(PremiumResellerMgmt('/_api/premium-reseller-mgmt').ResellerInternal()(), {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  }
});
export const PremiumMyDomainsApiConfig = createMetroApiConfig({
  listSites,
  getSite,
  listAssignedDomains,
  listUnassignedDomains,
  bindDomain,
  bindMultipleDomains,
  unbindDomain
});
export const PremiumUserDomainApiConfig = createMetroApiConfig(PremiumUserDomain);
export const PremiumCurrencyApiConfig = createMetroApiConfig(PremiumCurrencyService, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.FIXED_DATA
  }
});
export const DynamicOfferingApiConfig = createProtoV1ApiConfig(PremiumStore('/store').DynamicOfferingApi()(), {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.REALTIME_DATA
  }
});
export const MetaSiteInstanceApiConfig = createProtoV1ApiConfig(WixMetaSiteManagerWebapp('/_api/msm').MetaSiteReadApi()(), {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  methodsOptions: {
    getEditorClientSpecMap: {
      reactQueryOptions: {
        staleTime: 1000 * 60 * 60 * 4,
        refetchOnWindowFocus: true
      }
    }
  }
});
export const DomainRegistrarApiConfig = createProtoV1ApiConfig(PremiumDomainRegistrar('/_api/domain-registrar').Registrar()());
//# sourceMappingURL=ProtoServicesApiConfigs.js.map